<div #stickyHeader id="sticky-header">
  <ng-content></ng-content>
</div>
